import { useMutation, useQuery } from '@tanstack/react-query'
import { TUseMutationOptions, TUseQueryOptions } from 'core/query/type'
import {
  TPostMarketSearchResultParams,
  TPostMarketSearchResultResponse,
  postMarketSearchResult,
} from 'core/service/yapi/hk-web/MarketCalc/api'

// 币对搜索结果 - 查询方式
export const useGetMarketSearchResultQuery = (
  params?: TPostMarketSearchResultParams,
  options?: TUseQueryOptions<TPostMarketSearchResultResponse>
) => {
  return useQuery({
    ...options,
    queryKey: ['MarketCalc', 'MarketSearchResult', 'GET', ...Object.values(params || {})],
    queryFn: () => postMarketSearchResult(params),
  })
}
